import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { formatarValorMonetario } from "../../../../../../helpers/masks"
import { Ocorrencia } from "../../../../../../types/api/financeiro/detalhar-integracao-bancaria"
import ChipWithTooltip from "../../../../../../components/ChipWithTooltip"
import DataSemResultados from "../../../../../../components/DataSemResultados"

export default function TableDadosEEFI({
    rows
}: TableDadosEEFIProps) {
    return (
        <TableContainer sx={{ maxHeight: "74vh" }}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ minWidth: 105 }} align="right"><b>N° Parcela</b></TableCell>
                        <TableCell sx={{ minWidth: 152 }} align="right"><b>Valor lançamento</b></TableCell>
                        <TableCell align="right"><b>Valor bruto</b></TableCell>
                        <TableCell sx={{ minWidth: 148 }} align="right"><b>Soma dos títulos</b></TableCell>
                        <TableCell><b>Status</b></TableCell>
                        <TableCell sx={{ minWidth: 142 }} align="right"><b>Resumo vendas</b></TableCell>
                        <TableCell align="right"><b>Estabelecimento</b></TableCell>
                        <TableCell sx={{ minWidth: 175 }}><b>Títulos relacionados</b></TableCell>
                    </TableRow>
                </TableHead>

                {
                    rows.length > 0 &&
                    <TableBody>
                        {rows.map((row) => {
                            const status = row.status

                            let colorBg = ''
                            if (status === "Aguardando finalização") colorBg = "#e5f6fd"
                            if (status === "Conflito encontrado") colorBg = "#fff9e6"
                            if (status === "Finalizado") colorBg = "#e5fde5"

                            return (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: colorBg }}
                                >
                                    <TableCell align="right">{row.resumo_dados.parcela}</TableCell>
                                    <TableCell align="right">{formatarValorMonetario(row.resumo_dados.valor_lancamento)}</TableCell>
                                    <TableCell align="right">{formatarValorMonetario(row.resumo_dados.valor_bruto)}</TableCell>
                                    <TableCell align="right">{formatarValorMonetario(row.resumo_dados.total_valor_receber)}</TableCell>
                                    <TableCell >{row.status}</TableCell>
                                    <TableCell align="right">{row.resumo_dados.resumo_vendas}</TableCell>
                                    <TableCell align="right">{row.resumo_dados.estabelecimento}</TableCell>
                                    <TableCell >
                                        {row.resumo_dados.titulos_relacionados.length <= 0 && '-'}
                                        {row.resumo_dados.titulos_relacionados[0]}
                                        {
                                            row.resumo_dados.titulos_relacionados.length > 1 &&
                                            <ChipWithTooltip
                                                quebraLinha
                                                extraLabels={row.resumo_dados.titulos_relacionados.slice(1)}
                                                label={`+${row.resumo_dados.titulos_relacionados.length - 1}`}
                                            />
                                        }
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                }
                {
                    rows.length === 0 &&
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={10} align="center">
                                <DataSemResultados size="medium" texto="Nenhum resultado encontrado" />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                }
            </Table>
        </TableContainer>
    )
}

interface TableDadosEEFIProps {
    rows: Ocorrencia[]
}
